<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">教学质量评价</h3>
    <div>
      <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="教学质量评价" name="first"> -->
          <DoGrade  ref="doGrade"   />
        <!-- </el-tab-pane>
        <el-tab-pane label="我评价的" name="second">
          <AlreadyDo ref="alreadyDo" />
        </el-tab-pane>
      </el-tabs> -->
    </div>
   <div></div>
  </div>
</template>

<script>
import DoGrade from './components/doGrade';
// import AlreadyDo from './components/alreadyDo';
// import Refused from './components/Refused';


export default {
  name: 'trainingRoom',
  data() {
    return {
      activeName: 'first',
    };
  },
  components: {
    DoGrade,
    // AlreadyDo
  },
  created() {},
  mounted() {
    // this.getList();
    // this.handleClick({name:this.activeName})
  },
  methods: {
    handleClick(tab, event){
      switch(tab.name){
        case 'first':
          this.$refs.doGrade.getList();
          break;
        // case 'second':
        //   this.$refs.passed.getList();
        //   break;
        default:
          this.$refs.alreadyDo.getList();
          break;
      }
    },
    onSubmit() {
      console.log('submit!');
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
